import { ButtonInfos } from '@shared/utils/ButtonInfos';

const formatButtonAttatched = (attachedKeys: string[] = []) => {
  return ButtonInfos.filter((button) => attachedKeys.includes(button.key));
};

export default formatButtonAttatched;
